import ItemsFieldsModel from './ItemsFieldsModel';

export default class ItemsModel {
  constructor() {
    this['displayName'] = '';

    this['fields'] = new ItemsFieldsModel();

    this['id'] = '';

    this['name'] = '';

    this['url'] = '';
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'displayName')) {
      this['displayName'] = dataSource['displayName'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'displayName')) {
      this['fields'].getData(dataSource['fields']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'id')) {
      this['id'] = dataSource['id'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'name')) {
      this['name'] = dataSource['name'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'url')) {
      this['url'] = dataSource['url'];
    }

    return this;
  }
}
